<!-- Migration Process -->
<div *ngIf="!isHosted && isActive && (!!migrationInProgress || !!isUploading)" class="db-overlay-content">
  <db-loading-circular-spinner class="mb5"></db-loading-circular-spinner>
  <p [innerHTML]="(!!isUploading ? 'text_websiteMigrateZipOnItsWayLine' : (migrationInProgress ? (ongoingMigrationActivity?.meta?.is_clone ? 'text_websiteCloneOnItsWay' : 'text_websiteMigrateOnItsWay') : 'text_migrateYourWebsite')) | dbText"
  [ngClass]="{'text-underline text-bold' : !!isUploading}"></p>
  <p *ngIf="!!isUploading" [innerHTML]="'text_dontReloadPage' | dbText"></p>
</div>
<!-- Migration Process end -->

<!-- Migrate Connected -->
<div class="text-center"
     *ngIf="!isNetwork && !isHosted && isActive && !isLocalHost && !migrationInProgress && !isUploading
       && ([userSubscriptionType.FREE, userSubscriptionType.PLATFORM, userSubscriptionType?.DEDICATEDVM].includes(subscriptionType))">
  <button class="ds-btn ds-btn-small overlay-btn"
          *ngIf="role === clientRoles.OWNER && !disableMigrateButton"
          (click)="onMigrate.emit()">
    <span>{{hasCopy ? 'Migrate again' : 'Migrate'}}</span>
  </button>
  <p>
    <a class="ds-link-white mt10"
            *ngIf="role === clientRoles.OWNER && !disableMigrateButton && !!failedMigration"
            (click)="showUploadWithZipDialog()">
      <span>Migrate from a backup zip file</span>
    </a>
  </p>
</div>
<!-- Migrate Connected end -->

<!-- Disconnected Manager -->
<div *ngIf="!isActive && !isBooster" class="db-overlay-content">
  <i class="db-icon db-icon-ds- content-icon"></i>
  <p [innerHTML]="'text_websiteInactive' | dbText"></p>
  <a (click)="troubleshootInactiveWebsite()" [innerHTML]="'text_reconnect' | dbText"></a>
</div>
<!-- Disconnected Manager end -->

<!-- Disconnected Booster -->
<div *ngIf="isBooster && !isHosted" class="db-overlay-content">
  <p class="mb15" [innerHTML]="'Trouble connecting your website'"></p>
  <button class="ds-btn ds-btn-small" (click)="showBoosterPluginInstructions()">
    <span>Fix now</span>
  </button>
  <a class="mt10" *ngIf="cdnIsEnabled" (click)="redirect()">Manage Cloudflare settings only</a>
</div>
<!-- Disconnected Booster end -->

<!-- Unavailable -->
<div *ngIf="((subscriptionType !== userSubscriptionType.FREE) || loading)
     && ((isActive && isLocalHost) ) && !isBooster" class="db-overlay-content">
  <i class="db-icon db-icon-ds- content-icon"></i>
  <p [innerHTML]="'text_websiteUnavailable' | dbText"></p>
  <a [ngClass]="{'disabled': loading}"
     (click)="refreshWebsiteConnection()"><span>{{'text_refresh' | dbText}}</span></a>

</div>
<!-- Unavailable end -->


<!-- demo overlay for platform case -->
<div *ngIf="website?.isAiBuilderDemo && user?.platformClient" class="db-overlay-content">

  @if (demoLoading ) {
    <db-loading-circular-spinner></db-loading-circular-spinner>
    <p class="mt9" [innerHTML]="'text_websiteDemoCompleteSetupProgress' | dbText"></p>
  } @else {
    <button (click)="setupFlow()" [ngClass]="{'disabled': !!hostedLoading}" class="ds-label-purple-blue"><span [innerHTML]="'text_websiteDemoCompleteSetup' | dbText"></span></button>
  }
</div>

<!-- Unavailable end -->
